import React from 'react';
import styled from 'styled-components';
import { FaPills, FaShoppingBasket, FaTshirt, FaMobileAlt } from 'react-icons/fa';
import SectionTitle from '../common/SectionTitle';
import { theme } from '../../styles/GlobalStyles';

const SectionContainer = styled.section`
  padding: 5rem 0;
  background-color: ${theme.surfaceAlt};
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    bottom: -80px; right: -80px;
    width: 400px; height: 400px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(61,217,235,0.07) 0%, transparent 70%);
    pointer-events: none;
  }
`;

const ContentContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  position: relative;
  z-index: 1;
`;

const IndustriesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.25rem;
  @media (max-width: 992px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 576px) { grid-template-columns: 1fr; }
`;

const IndustryCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2.25rem 1.5rem;
  background: ${theme.cardBg};
  border: 1px solid ${theme.border};
  border-radius: 18px;
  backdrop-filter: blur(14px);
  transition: all 0.3s ease;
  cursor: default;

  &:hover {
    background: ${theme.cardBgHover};
    border-color: rgba(97,93,255,0.35);
    transform: translateY(-8px);
    box-shadow: 0 16px 48px rgba(97,93,255,0.2);
  }
`;

const IconContainer = styled.div`
  width: 80px; height: 80px;
  background: linear-gradient(135deg, rgba(97,93,255,0.15), rgba(61,217,235,0.1));
  border: 1px solid rgba(97,93,255,0.2);
  border-radius: 20px;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 1.25rem;
  font-size: 2rem; color: #615DFF;
  transition: all 0.3s ease;

  ${IndustryCard}:hover & {
    color: #3DD9EB;
    background: linear-gradient(135deg, rgba(97,93,255,0.25), rgba(61,217,235,0.15));
    box-shadow: 0 0 24px rgba(97,93,255,0.3);
  }
`;

const IndustryTitle = styled.h3`font-size:1rem;font-weight:600;color:${theme.text};`;

const industries = [
  { icon:<FaPills />,          title:'Pharma' },
  { icon:<FaShoppingBasket />, title:'FMCG' },
  { icon:<FaTshirt />,         title:'Fashion & Luxury' },
  { icon:<FaMobileAlt />,      title:'Electronics' },
];

const IndustriesSection = () => (
  <SectionContainer id="industries">
    <ContentContainer>
      <SectionTitle>Industries We Serve</SectionTitle>
      <IndustriesGrid>
        {industries.map((ind) => (
          <IndustryCard key={ind.title}>
            <IconContainer>{ind.icon}</IconContainer>
            <IndustryTitle>{ind.title}</IndustryTitle>
          </IndustryCard>
        ))}
      </IndustriesGrid>
    </ContentContainer>
  </SectionContainer>
);

export default IndustriesSection;
